export default Object.freeze({
  FieldValue: 1,
  FieldSearchValue: 2,
});
